exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".privacy-container {\n  padding: 20px 20px;\n  background: #fff; }\n\n.privacy-main-header,\n.privacy-sub-header,\n.privacy-bold {\n  color: #484848; }\n\n.privacy-main-header {\n  font-size: 22px;\n  margin-top: 0; }\n\n.privacy-sub-header {\n  font-size: 15px; }\n\n.privacy-bold {\n  font-size: 12px;\n  font-weight: 900; }\n\n.privacy-container p {\n  font-size: 12px;\n  color: #484848; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/PrivacyPolicy/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/common/PrivacyPolicy/index.css
// module chunks = 504